import { render, staticRenderFns } from "./add_approval.vue?vue&type=template&id=be637cda&scoped=true&"
import script from "./add_approval.vue?vue&type=script&lang=js&"
export * from "./add_approval.vue?vue&type=script&lang=js&"
import style0 from "./add_approval.vue?vue&type=style&index=0&id=be637cda&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be637cda",
  null
  
)

export default component.exports